document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    initializeCustomStickyBar();
  }, 100);
});

function initializeCustomStickyBar() {
  const stickyBars = document.querySelectorAll('product-sticky-bar');
  
  stickyBars.forEach(function(stickyBar) {
    const formId = stickyBar.getAttribute('form');
    if (!formId) return;
    
    const buyButton = document.querySelector(`#${formId} .buy-buttons`);
    const footer = document.querySelector('.shopify-section--footer');
    
    if (!buyButton) {
      console.warn('Buy button not found for sticky bar:', formId);
      return;
    }
    
    const buttonObserver = new IntersectionObserver(function(entries) {
      const buttonEntry = entries.find(entry => entry.target === buyButton);
      
      if (buttonEntry) {
        const shouldShow = !buttonEntry.isIntersecting;
        
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          const isFooterVisible = footerRect.top < window.innerHeight;
          
          if (isFooterVisible) {
            stickyBar.classList.remove('is-visible');
            return;
          }
        }
        
        stickyBar.classList.toggle('is-visible', shouldShow);
      }
    }, {
      threshold: 0,
      rootMargin: '0px 0px -10px 0px'
    });
    
    buttonObserver.observe(buyButton);
    
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          const isFooterVisible = footerRect.top < window.innerHeight;
          
          if (isFooterVisible) {
            stickyBar.classList.remove('is-visible');
          }
        }
      }, 10);
    });
    
    stickyBar._buttonObserver = buttonObserver;
  });
}

function cleanupStickyBarObservers() {
  const stickyBars = document.querySelectorAll('product-sticky-bar');
  stickyBars.forEach(function(stickyBar) {
    if (stickyBar._buttonObserver) {
      stickyBar._buttonObserver.disconnect();
    }
  });
}

window.addEventListener('beforeunload', cleanupStickyBarObservers); 